import { Notifications } from '@mantine/notifications';

export interface NotificationProviderProps {
  readonly children?: React.ReactNode;
}

/**
 * NotificationProvider wraps the application with Mantine's Notifications system.
 * It manages the display and positioning of toast notifications throughout the app.
 */
export function NotificationProvider({ children }: NotificationProviderProps) {
  return (
    <>
      <Notifications position="top-center" />
      {children}
    </>
  );
}
